import React, { useEffect, useMemo, useRef, useState } from "react";

import {
	DialogTitle,
	Dialog,
	DialogContent,
	Box,
	IconButton,
	Button,
	LinearProgress,
	Typography,
	useTheme,
	useMediaQuery,
	CircularProgress
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { LANG_AR, LANG_EN, RTL } from "../../Templates/WeddingTemplates/constants";
import langEN from "../../Templates/WeddingTemplates/lang.EN.json";
import langAR from "../../Templates/WeddingTemplates/lang.AR.json";
import { IGallery } from "../../../store/services/invitations/dto/invitations.dto";
import FileUploaderMultiple from "../../Inputs/FileUploaderMultiple";
import {
	useUploadMultipleFilesMutation,
	useOptimizeUploadMutation,
	useGetUploadUrlsMutation,
	useUploadFileMutation
} from "../../../store/services/file/file.service";
import { convertBase64ToFile } from "../../../utils/convertBase64ToFile";
import { notifyError } from "../../../utils/NotifyError";
import { IError } from "../../../utils/getErrorMessage";
import {
	useDeleteInvitationMemoryMutation,
	useGetWeddingInvitationMemoriesQuery,
	useLazyGetWeddingInvitationQuery,
	useUpdateInvitationMemoryMutation
} from "../../../store/services/invitations/invitations.service";
import { prepareImageList } from "../../../utils/prepareImageList";
import { getOrCreateAnonId } from "../../../utils/getOrCreateAnonId";
import { toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";
import ButtonComponent from "../../ButtonComponent";
import { PRICING_PLAN_CONFIG } from "../../../constants";
import { useAppSelector } from "../../../store";
import { getFullInvitationsState } from "../../../store/slices/invitations/invitations.slice";
import { useParams } from "react-router-dom";
import axios from "axios";
const UploadMemories = ({
	onClose,
	open,
	email,
	password,
	language,
	id
}: {
	open: boolean;
	onClose: () => void;
	email: string;
	password: string;
	language: string;
	id: string;
}) => {
	const lang = language === LANG_EN ? langEN : langAR;
	const [isDisabled, setIsDisabled] = useState(false);
	const [fieldValueState, setFieldValueState] = useState<IGallery[]>([]);
	// const [isSaving, setIsSaving] = useState(false);
	const [isDeletingLoading, setIsDeletingLoading] = useState(false);
	const [isUploadLoading, setIsUploadLoading] = useState(false);
	const [deleteImageId, setDeleteImageId] = useState<null | string>(null);
	const [callUploadMultipleFiles, { isLoading: isUploadingFiles }] = useUploadMultipleFilesMutation();
	const [callUploadMemories, { isLoading: isUploadingMemories }] = useUpdateInvitationMemoryMutation();
	const [callGetUploadUrls] = useGetUploadUrlsMutation();
	const [callOptimizeUpload] = useOptimizeUploadMutation();
	const [callDeleteMemory, { isLoading: isDeletingMemory }] = useDeleteInvitationMemoryMutation();
	const { selectedInvitation } = useAppSelector(getFullInvitationsState);
	const [fetchInvitation, { isLoading: isFetchingInvitation }] = useLazyGetWeddingInvitationQuery();
	const { data: weddingMemory } = useGetWeddingInvitationMemoriesQuery({ id: id, email, password }, { skip: !email });
	const [realProgress, setRealProgress] = useState(0);
	// const [displayProgress, setDisplayProgress] = useState(0);
	// const [fileSize, setFileSize] = useState(0);
	const theme = useTheme();
	const isSmallerScreen = useMediaQuery(theme.breakpoints.down("md"));
	const recaptchaRef = useRef<ReCAPTCHA>(null);

	useEffect(() => {
		if (weddingMemory && (weddingMemory?.items || []).length > 0) {
			setFieldValueState([...weddingMemory.items].sort((a, b) => a.order - b.order));
		}
	}, [weddingMemory]);

	useEffect(() => {
		if (id && !selectedInvitation) {
			fetchInvitation({ id });
		}
	}, [id, selectedInvitation]);

	// useEffect(() => {
	// 	const durationKB = fileSize / 1024;
	// 	const stepTime = 50;
	// 	const totalSteps = durationKB / stepTime;
	//
	// 	const interval = setInterval(() => {
	// 		setDisplayProgress(prev => {
	// 			if (prev < realProgress) {
	// 				const diff = realProgress - prev;
	//
	// 				const step = Math.max(1, Math.ceil(diff / totalSteps));
	//
	// 				return prev + step;
	// 			}
	// 			return prev;
	// 		});
	// 	}, stepTime);
	//
	// 	return () => clearInterval(interval);
	// }, [realProgress, fileSize]);

	useEffect(() => {
		return () => {
			if (recaptchaRef.current) recaptchaRef.current.reset();
		};
	}, []);

	const handleDeleteMemory = async (memoryId: string) => {
		if (!recaptchaRef.current) {
			return notifyError({ error: "Recaptcha failed" } as IError);
		}
		setIsDeletingLoading(true);
		let recaptchaToken: string | null = "";
		try {
			recaptchaToken = await recaptchaRef.current.executeAsync();
			console.log("TOKEN", recaptchaToken);
		} catch (e) {
			console.error(e);
		}
		const anonymous_token = getOrCreateAnonId(id);
		callDeleteMemory({
			_id: id as string,
			memoryItemId: memoryId,
			password,
			anonymous_token,
			recaptchaToken: recaptchaToken as string
		}).then(({ data, error }) => {
			if (data) {
				setDeleteImageId(null);
				toast.success("Image has been deleted.", { autoClose: 3000 });
			}
			if (error) {
				notifyError(error as IError);
			}
			setIsDeletingLoading(false);
		});
	};

	const handleUploadMemories = async () => {
		if (!recaptchaRef.current) {
			return notifyError({ error: "Recaptcha failed" } as IError);
		}
		setIsUploadLoading(true);
		let recaptchaToken: string | null = "";
		try {
			recaptchaToken = await recaptchaRef.current.executeAsync();
			console.log("TOKEN", recaptchaToken);
		} catch (e) {
			console.error(e);
		}

		// setIsSaving(true);

		const fileEntries: { file: File; mimeType: string }[] = [];
		// @ts-ignore
		for (const [, img] of (fieldValueState as IGallery[]).entries()) {
			const _shouldUploadImage = img.image_url.includes("data:image");
			if (_shouldUploadImage) {
				const file = await convertBase64ToFile(img.image_url as string, `wedding-memory-${id}-${img.order}.jpeg`);
				// setFileSize(prev => prev + file.size);
				fileEntries.push({ file, mimeType: file.type });
			}

			const isBlobVideo = img.video_url && img.video_url.startsWith("blob:");
			if (isBlobVideo) {
				const blob = await fetch(img.video_url).then(res => res.blob());
				const ext = blob.type.split("/")[1] || "mp4";
				const file = new File([blob], `wedding-memory-${id}-${img.order}.${ext}`, { type: blob.type });
				// setFileSize(prev => prev + file.size);
				fileEntries.push({ file, mimeType: file.type });
			}
		}

		if (fileEntries.length === 0) {
			// setIsSaving(false);
			setIsUploadLoading(false);
			return;
		}

		const anonymous_token = getOrCreateAnonId(id);
		const MAX_IMAGE_SIZE = PRICING_PLAN_CONFIG[selectedInvitation?.selectedPricingPlan || 0].image_size;
		const MAX_VIDEO_SIZE = PRICING_PLAN_CONFIG[selectedInvitation?.selectedPricingPlan || 0].video_size;

		try {
			// --- Step 1: get signed upload URLs from backend (tiny JSON request) ---
			const { data: urlData } = await callGetUploadUrls({
				files: fileEntries.map(({ file }) => ({
					fileName: file.name,
					mimeType: file.type,
					size: file.size
				})),
				path: `wedding_invitations_memories/${id}`,
				MAX_IMAGE_SIZE,
				MAX_VIDEO_SIZE,
				anonymous_token
			});

			if (urlData && !urlData.success) {
				// setIsSaving(false);
				setIsUploadLoading(false);
				return notifyError({ error: urlData.message } as IError);
			}

			// --- Step 2: upload each file directly to GCS (bypasses App Engine) ---
			const totalFiles = fileEntries.length;
			const progressPerFile = new Array(totalFiles).fill(0);
			if (!urlData) {
				return notifyError({ error: "Failed to get signed urls" } as IError);
			}
			const uploadedFiles = await Promise.all(
				urlData.files.map(async (signedFile: any, index: number) => {
					const { file } = fileEntries[index];

					const formData = new FormData();
					// GCS requires signed POST fields to come BEFORE the file
					Object.entries(signedFile.upload_fields).forEach(([key, val]) => {
						formData.append(key, val as string);
					});
					formData.append("file", file);

					await axios.post(signedFile.upload_url, formData, {
						onUploadProgress: e => {
							const total = e.total || file.size;
							const loaded = e.loaded || 0;

							progressPerFile[index] = Math.round((loaded * 100) / total);

							const totalProgress = Math.round(progressPerFile.reduce((a, b) => a + b, 0) / totalFiles);

							console.log(`File ${index} progress:`, progressPerFile[index], "Total:", totalProgress); // remove after debugging

							setRealProgress(totalProgress < 100 ? totalProgress : 99);
						}
					});

					return {
						file_path: signedFile.file_path,
						mimeType: signedFile.mimeType
					};
				})
			);

			// --- Step 3: optimize upload — backend triggers Cloud Run and returns read URLs ---
			const { data: optimizedData } = await callOptimizeUpload({
				files: uploadedFiles,
				toJPEG: "true",
				toWEBP: "false",
				invitationId: id,
				type: "memory",
				anonymous_token
			});

			if (!optimizedData?.success) {
				// setIsSaving(false);
				setIsUploadLoading(false);
				return notifyError({ error: optimizedData?.message } as IError);
			}

			// --- Step 4: same as before — update gallery list and save memories ---
			if (optimizedData.files && email) {
				const updateImageList = prepareImageList(optimizedData.files, fieldValueState as IGallery[]);

				callUploadMemories({
					_id: id,
					gallery: updateImageList,
					user_email: email,
					password,
					anonymous_token,
					recaptchaToken: recaptchaToken as string
				}).then(({ data, error }) => {
					if (data) {
						// setIsSaving(false);
						setRealProgress(0);
						// setDisplayProgress(0);
						// setFileSize(0);
						toast.success("Memories uploaded successfully.", { autoClose: 3000 });
					}
					if (error) {
						// setIsSaving(false);
						notifyError(error as IError);
					}
					setIsUploadLoading(false);
				});
			}
		} catch (err) {
			console.error("Upload error:", err);
			// setIsSaving(false);
			setIsUploadLoading(false);
			notifyError({ error: "Upload failed. Please try again." } as IError);
		}
	};

	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			maxWidth={"xs"}
			fullWidth={true}
		>
			<DialogTitle id="alert-dialog-title" className={`${language === LANG_AR && RTL}`}>
				{lang.UPLOAD_MEMORIES}
			</DialogTitle>
			<Box
				display="flex"
				justifyContent="flex-end"
				style={
					language === LANG_AR
						? { position: "absolute", left: "20px", top: "20px" }
						: { position: "absolute", right: "20px", top: "20px" }
				}
			>
				<IconButton onClick={onClose}>
					<Close />
				</IconButton>
			</Box>
			<DialogContent style={{ padding: 0 }}>
				<FileUploaderMultiple
					fieldValueState={fieldValueState as IGallery[]}
					setFieldValueState={setFieldValueState as React.Dispatch<React.SetStateAction<IGallery[]>>}
					deleteImageId={deleteImageId}
					setDeleteImageId={setDeleteImageId}
					onDeleteImage={handleDeleteMemory}
					isDeletingImage={isDeletingMemory || isDeletingLoading}
					isOrderDisabled={true}
					disableDelete={isUploadingMemories || isUploadLoading}
					isDisabled={isDisabled}
					setIsDisabled={setIsDisabled}
					max_image_size={PRICING_PLAN_CONFIG[selectedInvitation?.selectedPricingPlan || 0].image_size}
					max_video_size={PRICING_PLAN_CONFIG[selectedInvitation?.selectedPricingPlan || 0].video_size}
					maxFiles={PRICING_PLAN_CONFIG[selectedInvitation?.selectedPricingPlan || 0].memory_album_count}
				/>
			</DialogContent>
			<Box width={"100%"} p={1} style={{ boxSizing: "border-box" }}>
				{(isUploadingMemories || isUploadLoading) && realProgress > 0 ? (
					<Box
						style={{
							position: "sticky",
							bottom: 72,
							width: isSmallerScreen ? "100%" : "450px",
							background: isSmallerScreen ? "#fff" : "unset",
							zIndex: 1000,
							display: "flex",
							justifyContent: "center",
							alignItems: "flex-start",
							padding: "20px 0"
						}}
					>
						{realProgress < 99 ? (
							<Box display={"flex"} width={"90%"} alignItems={"center"} justifyContent={"space-between"}>
								<LinearProgress variant={"determinate"} value={realProgress} style={{ flexGrow: 1 }} />
								<Typography style={{ paddingLeft: "10px", flexBasis: "35px" }}>{realProgress + "%"}</Typography>
							</Box>
						) : (
							<Typography style={{ fontFamily: "var(--poppins)", fontSize: "16px" }}>Processing...</Typography>
						)}
					</Box>
				) : null}
				<ButtonComponent
					fullWidth
					variant={"contained"}
					onClick={handleUploadMemories}
					autoFocus
					loading={isUploadLoading}
					disabled={isUploadLoading || fieldValueState.length === (weddingMemory?.items || []).length}
					text={"Upload"}
				/>
			</Box>
			<ReCAPTCHA
				sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY as string}
				size="invisible"
				ref={recaptchaRef}
				badge="bottomright"
			/>
		</Dialog>
	);
};

export default UploadMemories;
